import { ENREGISTRE, ENVOYE } from '@/configuration/relances/relancesConf';

export default function genererCritereRelance() {
  return {
    codeFacture: null,
    datesFacture: {
      dateDebut: null,
      dateFin: null,
    },
    datesRelance: {
      dateDebut: null,
      dateFin: null,
    },
    tiersId: [],
    commercialId: null,
    agenceIdFacture: [],
    actif: true,
    etat: [ENREGISTRE, ENVOYE],
    comptesComptables: [],
    payeurs: [],
  };
}
